module.exports = __webpack_public_path__ + "assets/img/pickStar-rule.60ccb76e.png";